import { useState } from "react";

const dealers = ["Teknoloji Dünyası", "Bilgisayar Plaza", "Ofis Market", "Ana Bayi"];
const types = ["Müşteri İadesi", "Garanti Değişimi", "Hasarlı Ürün", "Yanlış Gönderim"];

const allData = [
  { date: "2026-07-16", product: "Kablosuz Mouse", brand: "Logitech", qty: 2, amount: 900, dealer: "Teknoloji Dünyası", type: "Müşteri İadesi", reason: "Arızalı" },
  { date: "2026-07-15", product: "27\" Monitör", brand: "Samsung", qty: 1, amount: 3500, dealer: "Bilgisayar Plaza", type: "Garanti Değişimi", reason: "Ölü piksel" },
  { date: "2026-07-14", product: "USB-C Hub", brand: "Dell", qty: 3, amount: 960, dealer: "Ofis Market", type: "Yanlış Gönderim", reason: "Yanlış model" },
  { date: "2026-07-13", product: "Webcam 1080p", brand: "Logitech", qty: 1, amount: 680, dealer: "Ana Bayi", type: "Müşteri İadesi", reason: "Memnuniyetsizlik" },
  { date: "2026-07-12", product: "Mechanik Klavye", brand: "Corsair", qty: 2, amount: 2400, dealer: "Teknoloji Dünyası", type: "Hasarlı Ürün", reason: "Kutu hasarlı" },
  { date: "2026-07-11", product: "Laptop Standı", brand: "HP", qty: 1, amount: 290, dealer: "Ofis Market", type: "Müşteri İadesi", reason: "Memnuniyetsizlik" },
];

export default function ReturnsReport() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dealer, setDealer] = useState("");
  const [returnType, setReturnType] = useState("");
  const [search, setSearch] = useState("");

  const data = allData.filter((i) => {
    if (startDate && i.date < startDate) return false;
    if (endDate && i.date > endDate) return false;
    if (dealer && i.dealer !== dealer) return false;
    if (returnType && i.type !== returnType) return false;
    if (search && !i.product.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const total = data.reduce((sum, d) => sum + d.amount, 0);

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-foreground-700 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">İadeler Rapor Kriterleri</span>
          <button onClick={() => { setStartDate(""); setEndDate(""); setDealer(""); setReturnType(""); setSearch(""); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tarih Aralığı</label>
            <div className="flex items-center gap-2">
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-foreground-400" />
              <span className="text-sm text-foreground-400">-</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-foreground-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Cari Bayi</label>
            <select value={dealer} onChange={(e) => setDealer(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-foreground-400 cursor-pointer">
              <option value="">Tümü</option>
              {dealers.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">İade Tipi</label>
            <select value={returnType} onChange={(e) => setReturnType(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-foreground-400 cursor-pointer">
              <option value="">Tümü</option>
              {types.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div className="sm:col-span-2 lg:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Ürün Ara</label>
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type="text" placeholder="Ara..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full pl-9 pr-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-foreground-400" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">İade Listesi</h2>
        <div className="flex items-center gap-3">
          <span className="text-sm text-foreground-500">{data.length} kayıt</span>
          <span className="text-sm font-semibold text-foreground-700">Toplam: ${total.toLocaleString("en-US")}</span>
        </div>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Tarih</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Ürün</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Marka</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Tutar</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">İade Tipi</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Neden</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Bayi</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 text-foreground-500">{item.date}</td>
                <td className="px-4 py-3 font-medium text-foreground-900">{item.product}</td>
                <td className="px-4 py-3 text-foreground-500">{item.brand}</td>
                <td className="px-4 py-3 text-center text-foreground-900">{item.qty}</td>
                <td className="px-4 py-3 text-right font-semibold text-foreground-900">${item.amount.toLocaleString("en-US")}</td>
                <td className="px-4 py-3">
                  <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-foreground-100 text-foreground-700">{item.type}</span>
                </td>
                <td className="px-4 py-3 text-foreground-500">{item.reason}</td>
                <td className="px-4 py-3 text-foreground-500">{item.dealer}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-foreground-900">{item.product}</p>
                <p className="text-xs text-foreground-400">{item.brand} · {item.date}</p>
              </div>
              <p className="text-sm font-bold text-foreground-900">${item.amount.toLocaleString("en-US")}</p>
            </div>
            <div className="flex items-center justify-between mt-2">
              <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-foreground-100 text-foreground-700">{item.type}</span>
              <p className="text-xs text-foreground-500">{item.dealer}</p>
            </div>
            <p className="text-xs text-foreground-400 mt-1">Neden: {item.reason}</p>
          </div>
        ))}
      </div>
    </div>
  );
}